import { observer } from "mobx-react";

import BaseComponent from "@component/BaseComponent";
import HealthInsuranceList from "./List";

@observer
export default class HealthInsuranceShow extends BaseComponent<PropsFromRouter> {
  render() {
    return (
      <>
        <HealthInsuranceList match={this.props.match} />
      </>
    );
  }
}
